export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return null;
};

export const getFacebookPixelCookie = (): string | null => {
  return getCookie('_fbp') ?? '';
};

export const getFacebookClickIdCookie = (): string | null => {
  // _fbc is typically set by Facebook ads if a user clicks through.
  // It might also be under a different name like _fcl if configured, or gclid for Google Ads.
  // We'll stick to _fbc for now.
  return getCookie('_fbc') ?? '';
}; 

/** Sets a cookie with sane defaults. */
export const setCookie = (name: string, value: string, maxAgeDays: number): void => {
  try {
    const maxAgeSeconds = Math.max(1, Math.floor(maxAgeDays * 24 * 60 * 60));
    const secure = window.location.protocol === 'https:' ? '; secure' : '';
    document.cookie = `${name}=${value}; path=/; samesite=lax; max-age=${maxAgeSeconds}${secure}`;
  } catch {
    // no-op
  }
};

/** Returns a persistent visitor id, creating and storing one if missing. */
export const getOrCreateVisitorId = (cookieName: string = 'dac_visitor_id'): string => {
  const existing = getCookie(cookieName);
  if (existing && existing.length > 0) return existing;

  let newId: string;
  // Prefer crypto.randomUUID when available
  try {
    // @ts-ignore - older TS lib may not know about randomUUID
    newId = typeof crypto !== 'undefined' && typeof (crypto as any).randomUUID === 'function'
      ? (crypto as any).randomUUID()
      : `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
  } catch {
    newId = `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
  }

  // Ensure "demo." prefix for analytics visibility
  newId = `demo.${newId}`;

  setCookie(cookieName, newId, 365 * 2);
  return newId;
};